<div class="root">
  <my-top-menu-dropdown [menuEntries]="menuEntries"></my-top-menu-dropdown>

  <div class="margin-content pb-5" [ngClass]="{ 'sub-menu-offset-content': !isBroadcastMessageDisplayed }">
    <router-outlet></router-outlet>
  </div>
</div>
